/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';

export const Container = styled.div`
  min-height: 300px;
  margin-top: 30px;
  padding: 0 15px;
  @media (max-width: 480px) {
    padding: 0 2px;
  }
`;
